import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { MyApColorTheme } from '@app/shared/enums';
import { LineSeparatorStyle } from './line-separator.constant';

@Component({
  selector: 'app-line-separator',
  templateUrl: './line-separator.component.html',
  styleUrls: ['./line-separator.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: []
})
export class LineSeparatorComponent implements OnInit {
  @Input() width: LineSeparatorStyle;
  @Input() color: MyApColorTheme = MyApColorTheme.WHITE;

  constructor() { }

  ngOnInit(): void {
  }

  get getSeparatorStyle() {
    return this.width == LineSeparatorStyle.BOLDER ? "line-separator-bolder" : "line-separator-normal";
  }

  get getSeparatorColor() {
    switch (this.color) {
      case MyApColorTheme.WHITE:
        return "line-separator-light";
      case MyApColorTheme.BLUE:
        return "ap-blue";
      case MyApColorTheme.GREEN:
        return "ap-green";
      default:
        return "line-separator-dark";
    }
  }

}
